<script>
import { mapState } from 'vuex'

export default {
  data: () => ({
    showModal: false,
    isForHandover: false,
  }),

  computed: {
    ...mapState({
      refreshBooking: (state) => state.global.refreshBooking,
      refreshHandover: (state) => state.global.refreshHandover,
    }),

    changesForText() {
      return !this.isForHandover ? 'booking' : 'handover'
    },
  },

  watch: {
    refreshBooking(val) {
      this.showModal = val
    },
    refreshHandover(val) {
      this.showModal = val
      this.isForHandover = true
    },
  },

  methods: {
    onAction() {
      window.location.reload()
    },
  },
}
</script>

<template>
  <b-modal
    v-model="showModal"
    title="New Details"
    header-class="col12 bg-primary text-white text-center closeButton"
    title-class="w-100"
    hide-footer
    centered
    no-close-on-backdrop
    hide-header-close
  >
    <template #default>
      <b-row class="justify-content-center">
        <b-col
          cols="12"
          class="text-center"
        >
          <p>
            Some changes have been made to this {{ changesForText }}. Please refresh the page to ensure you have the
            latest information.
          </p>
        </b-col>
      </b-row>
      <b-row class="justify-content-center mt-3">
        <b-col cols="4">
          <b-button
            variant="primary"
            block
            @click="onAction"
            >Refresh Page</b-button
          >
        </b-col>
      </b-row>
    </template>
  </b-modal>
</template>
